import React, { useState, useEffect } from "react"
import styled from "@emotion/styled"
import { injectIntl, Link } from "gatsby-plugin-intl"
import { FaAngleLeft, FaAngleRight } from "react-icons/fa"

const FaqListPrevNextSectionWrapper = styled.div`
  width: 100%;
  position: relative;
  display: none;

  @media (max-width: 850px) {
    display: flex;
    margin-bottom: 20px;
  }
`

const FaqCurrBox = styled.div`
  width: 100%;
  position: relative;
  background: #eaeaea;
  padding: 10px 20px;
  font-size: 16px;
  line-height: 20px;
  font-family: "Gotham Book";
  display: flex;
  align-items: center;
  justify-content: center;
`

const FaqPrevPostBox = styled(Link)`
  padding: 10px 15px;
`

const FaqNextPostBox = styled(Link)`
  padding: 10px 15px;
`

const LeftArrowWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 0px;
  height: 30px;
  transform: translate(0%, -50%);
`

const RightArrowWrapper = styled.div`
  position: absolute;
  top: 50%;
  right: 0px;
  height: 30px;
  transform: translate(0%, -50%);
`

const FaqListPrevNextSection = ({
  intl,
  data,
  title,
  sidebarKey,
  catPage,
  productCatPage,
  productCatkey,
  productCatTitle,
}) => {
  const [currIndex, setcurrIndex] = useState(0)
  const [pageData, setpageData] = useState({})
  const getCatIndex = (itemData, key) => {
    if (itemData && key) {
      setpageData(itemData)
      itemData.forEach((item, index) => {
        if (item.key === key) {
          setcurrIndex(index)
        }
      })
    }
  }
  const getPostIndex = (itemData, key, title) => {
    if (itemData && key) {
      itemData.forEach((item, index) => {
        if (item.key === key && item.item_list) {
          setpageData(item.item_list)
          item.item_list.forEach((list_item, item_index) => {
            if (list_item && list_item.item_title) {
              if (list_item.item_title === title) {
                setcurrIndex(item_index)
              }
            }
          })
        }
      })
    }
  }

  useEffect(() => {
    if (data && sidebarKey && catPage) {
      getCatIndex(data, sidebarKey, title)
    }
    if (data && sidebarKey && title) {
      getPostIndex(data, sidebarKey, title)
    }
  }, [])

  return (
    data &&
    sidebarKey &&
    pageData && (
      <FaqListPrevNextSectionWrapper>
        {catPage && currIndex > 0 && pageData[currIndex - 1] && (
          <FaqPrevPostBox to={pageData[currIndex - 1].link}>
            <LeftArrowWrapper>
              <FaAngleLeft size={30} />
            </LeftArrowWrapper>
          </FaqPrevPostBox>
        )}
        {catPage && currIndex >= 0 && pageData[currIndex] && (
          <FaqCurrBox to={pageData[currIndex].link}>
            {pageData[currIndex].title}
          </FaqCurrBox>
        )}
        {catPage && currIndex >= 0 && pageData[currIndex + 1] && (
          <FaqNextPostBox to={pageData[currIndex + 1].link}>
            <RightArrowWrapper>
              <FaAngleRight size={30} />
            </RightArrowWrapper>
          </FaqNextPostBox>
        )}
        {title && currIndex > 0 && pageData[currIndex - 1] && (
          <FaqPrevPostBox to={pageData[currIndex - 1].item_link}>
            <LeftArrowWrapper>
              <FaAngleLeft size={30} />
            </LeftArrowWrapper>
          </FaqPrevPostBox>
        )}
        {title && currIndex >= 0 && pageData[currIndex] && (
          <FaqCurrBox to={pageData[currIndex].item_link}>
            {pageData[currIndex].item_title}
          </FaqCurrBox>
        )}
        {title && currIndex >= 0 && pageData[currIndex + 1] && (
          <FaqNextPostBox to={pageData[currIndex + 1].item_link}>
            <RightArrowWrapper>
              <FaAngleRight size={30} />
            </RightArrowWrapper>
          </FaqNextPostBox>
        )}
      </FaqListPrevNextSectionWrapper>
    )
  )
}

export default injectIntl(FaqListPrevNextSection)
